export type Tomo = {
  number: number;
  title: string;
  subtitle?: string;
  description: string;
};
export type Bono = {
  number: number;
  title: string;
  description: string;
  price: string;
};
export type Testimonial = {
  initials: string;
  name: string;
  location: string;
  quote: string;
};
export type Faq = {
  question: string;
  answer: string[];
};
export const painPoints: string[] = ["Desayuno \"sano\" pero igual la hinchazón permanece.", "Almuerzo normal pero a media tarde llega una sensación de pesadez y cansansio", 'Noches donde no sabés si fue la comida, el estrés o mala suerte.', 'Horas perdidas buscando qué deberías comer, sin instrucciones claras.', 'Culpa permanente porque "comés bien pero el cuerpo no responde".'];
export const tomos: Tomo[] = [{
  number: 1,
  title: 'El Despertar',
  description: 'Por qué comés "sano" pero seguís inflamada. Cómo el intestino influye en hinchazón, cansancio, dolores y otros síntomas que probablemente normalizaste.'
}, {
  number: 2,
  title: 'Protocolo Reset',
  subtitle: 'Fase 1 — Días 1 a 7',
  description: 'Guía completa de los primeros 7 días para reducir irritantes, simplificar la alimentación y darle descanso total al sistema digestivo.'
}, {
  number: 3,
  title: 'Protocolo Reintegro',
  subtitle: 'Fase 2 — Días 8 a 15',
  description: 'Paso a paso para reintroducir alimentos ordenadamente y descubrir cuáles detonan hinchazón, cansancio, gases o malestar.'
}, {
  number: 4,
  title: 'Botiquín Natural',
  description: 'Hábitos, suplementos seguros, infusiones, nervio vago y estrategias para acompañar tu reparación intestinal.'
}, {
  number: 5,
  title: 'Recetario Salud Plena',
  description: "50 recetas simples, prácticas y antiinflamatorias. Comida que cura sin ser restrictiva ni aburrida."
}, {
  number: 6,
  title: 'Estilo de Vida Pro-Longevidad',
  description: 'Cómo mantener resultados indefinidamente. Hábitos para prevenir recaídas y construir una rutina más saludable a largo plazo.'
}];
export const bonos: Bono[] = [{
  number: 1,
  title: 'Diario Anti-Hinchazón 15 Días',
  description: 'Registrá comidas, síntomas, energía y sueño e identificá patrones. Descubrí exactamente qué alimentos detonan tu hinchazón y cuáles te hacen sentir bien.',
  price: "USD 7.00"
}, {
  number: 2,
  title: 'Lista Inteligente de Compras Salud Plena',
  description: 'Sabé exactamente qué comprar, qué evitar y cómo organizar tu cocina. Se termina la confusión de "¿esto puedo comerlo o no?". Todo claro y listo.',
  price: "USD 9.00"
}, {
  number: 3,
  title: 'Plan SOS 48 Horas para Brotes de Inflamación',
  description: 'Si aparece hinchazón o malestar, tenés una guía rápida para volver a lo simple y recuperarte en 48 horas sin abandonar todo.',
  price: "USD 8.00"
}, {
  number: 4,
  title: 'Mapa Personal de Disparadores Alimentarios',
  description: 'Clasificá tus alimentos en verde, amarillo y rojo según tu tolerancia REAL. Dejá de seguir listas genéricas y construí tu propio semáforo.',
  price: "USD 8.00"
}, {
  number: 5,
  title: 'Kit Comer Fuera Sin Inflamarte',
  description: 'Estrategias para restaurantes, reuniones familiares, viajes y vida social. Comé conscientemente sin volver a casa hinchada, culpable o confundida.',
  price: "USD 11.00"
}, {
  number: 6,
  title: 'Ritual Digestivo Nocturno Naturia',
  description: 'Una rutina simple de 20 minutos para mejorar la digestión nocturna, dormir profundo y despertar sin hinchazón. La noche que te devuelve tu cuerpo.',
  price: 'USD 8.00'
}];
export const miniTestimonials: Testimonial[] = [{
  initials: 'MV',
  name: 'María V.',
  location: 'Córdoba, Argentina',
  quote: "Despues de 2 semanas me sentí diferente, decaí en la primer semana pero finalmente entiendo qué me inflama."
}, {
  initials: 'LC',
  name: 'Laura C.',
  location: 'Ciudad de México, México',
  quote: "Me sentí identificada con tu testimonio donde decías que estabas cansada de que los médicos dijeran que estabas bien pero te sientas mal. Además de tener 35 años y sentirte de 65. Muy recomendado, aunque me costó un poco las recetas ya que no se cocinar!"
}, {
  initials: 'AP',
  name: 'Ana P.',
  location: 'Bogotá, Colombia',
  quote: "Lo que me gustó es que te enseña a escuchar tu cuerpo, me costó un poco ya que no se cocinar y no me gusta, pero ahora entendiendo que me inflama!"
}];
export const testimonials: Testimonial[] = [{
  initials: 'MV',
  name: 'María V.',
  location: 'Madrid, España',
  quote: "Compré un domingo por la noche. El lunes tenía todo claro: qué comer, qué evitar y cómo preparar. Nunca pensé que en unos días me cambiarían tanto. Cuando me hincho, puedo retomarlo y en 48 horas estoy normal."
}, {
  initials: 'JL',
  name: 'Juan L.',
  location: 'México · Ciudad de México',
  quote: "Lo que me gustó es que te enseña a escuchar tu cuerpo. Dejé de culparme sobre lo que hacia mal y comencé desde cero"
}, {
  initials: 'AP',
  name: 'Ana P.',
  location: "Buenos Aires, Argentina",
  quote: "Dormía mal durante años. Ahora duermo profundo y despierto sin hinchazón. Es simple pero funciona de verdad. Mis amigas vieron el cambio!"
}, {
  initials: 'CR',
  name: 'Carla R.',
  location: 'Perú · Lima',
  quote: "Pensé que sería restrictivo. Pero el Recetario tiene 50+ recetas que me gustan de verdad. En especial el Kit para comer afuera me permitió seguir saliendo y comer sin hinchazón. No sentí que me perdiera algo."
}, {
  initials: 'DM',
  name: 'Diego M.',
  location: 'Chile · Santiago',
  quote: "Como ingeniero puedo reconocer la información que necesitaba para sentirme mejor. Me siento mucho mejor ahora y ya no tengo esos dolores de cabeza."
}, {
  initials: 'FG',
  name: 'Fernanda G.',
  location: 'España · Madrid',
  quote: "Dudé porque pensé que era otro libro más generado por IA, pero la verdad que no fue así. Me sentí identificada con tu testimonio donde decías que estabas cansado de que los médicos dijeran que estas bien pero te sientas mal. Además de tener 35 y sentirte de 65 años. Muy recomendado!"
}, {
  initials: 'RH',
  name: 'Rosa H.',
  location: 'Guatemala · Ciudad de Guatemala',
  quote: "Lo que más valoro es que está todo en un solo lugar. Organizado y progresivo. Listo para empezar."
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Uruguay · Montevideo',
  quote: "Un fin de semana comí algo que no debía y me hinché de nuevo. Pensé que debía volver a empezar. Usé el plan, volví a lo simple y en 48 horas estaba normal. Aprendí que un error no borra 15 días de progreso. A seguir!"
}];
export const currencies: string[] = ['Pesos argentinos', 'Pesos mexicanos', 'Pesos colombianos', 'Soles peruanos', 'Pesos chilenos', 'Euros', 'Quetzales', 'Bolívares', 'Colones', 'Lempiras', 'Balboas', 'Córdobas'];
export const faqs: Faq[] = [{
  question: '¿Cómo recibo el MegaPack después de comprar?',
  answer: ['De forma inmediata recibirás un email de confirmación con el acceso. Los 6 tomos + 6 bonos son archivos PDF descargables.', 'Podés leerlos desde tu celular, tablet, computadora o imprimirlos si lo preferís. No es un producto físico: es acceso digital inmediato.']
}, {
  question: '¿Sirve para mi país? ¿Solo es para Argentina o Latinoamérica?',
  answer: ['Funciona para TODO el mundo hispanohablante. Está escrito en español neutro, sin regionalismos. De España a México. De Colombia a Chile. De Guatemala a Perú.', 'Las opciones de alimentos, las recetas y los protocolos son adaptables a la disponibilidad de cada país. En la Lista Inteligente de Compras (Bono 2) hay instrucciones de sustituciones si ciertos alimentos no están disponibles en tu región.']
}, {
  question: '¿El protocolo es solo para SIBO o también funciona para hinchazón general?',
  answer: ['El protocolo funciona para cualquier tipo de hinchazón, distensión abdominal, gases, digestión lenta o síntomas digestivos. NO es específico para SIBO.', 'Es un protocolo de reset intestinal y reintroducción ordenada de alimentos que funciona tanto si tenés diagnóstico como si simplemente te sentís inflamada sin saber por qué.', 'Está diseñado para personas que sienten hinchazón crónica, independientemente de si tienen SIBO confirmado, IBS, intolerancia a alimentos o simple sensibilidad digestiva.']
}, {
  question: '¿El contenido es editable? ¿Puedo modificarlo?',
  answer: ['Los archivos son PDF. Podés imprimirlos, escribir notas y adaptar ejemplos a tu contexto local.', 'NO podés compartir ni revender el contenido: es una licencia personal para tu uso. Pero SÍ podés adaptar, personalizar y usar el material en tu vida según tus necesidades.']
}, {
  question: '¿Los 6 bonos están en todas las ofertas?',
  answer: ['SÍ. Los 6 bonos van con cualquier compra. No hay "versión básica sin bonos".', 'El valor total real es USD 76.80 (tomos + bonos). Hoy pagás USD 19.99.']
}, {
  question: '¿Este es un material médico? ¿Reemplaza a un profesional?',
  answer: ['NO. Este es material educativo e informativo. NO reemplaza diagnóstico, tratamiento ni seguimiento médico profesional.', 'Si tenés una condición médica diagnosticada (Crohn, colitis, SIBO confirmado con tests, alergias alimentarias, embarazo, lactancia, medicaciones, síntomas intensos o dolor persistente), consultá ANTES de implementar cualquier cambio alimentario.', 'El MegaPack Salud Plena es complementario al tratamiento profesional, no un sustituto.']
}, {
  question: '¿Cuánto tiempo toma ver resultados?',
  answer: ['Persona a persona es diferente. En promedio: Semana 1, mejora del sueño y gases reducidos. Semana 2, la hinchazón visible comienza a bajar. Semana 3, cambios notables en energía y digestión. Semanas 4 a 8, transformación que ves en el espejo.', 'Algunos ven cambios en 48 horas. Otros tardan 3 semanas. Lo importante: consistencia de 15 días + ritual nocturno + evitar detonantes. Esos factores determinan los resultados.']
}, {
  question: '¿Qué pasa si estoy fuera del protocolo (viajando, eventos sociales)?',
  answer: ['El Bono 5 "Kit Comer Fuera Sin Inflamarte" te da estrategias exactas para restaurantes, reuniones familiares, viajes, eventos sociales y presión social.', 'Podés comer fuera SIN volver a casa hinchada, culpable o confundida.']
}, {
  question: '¿En qué moneda pago?',
  answer: ['Pagás en la moneda de tu país. El sistema detecta tu ubicación y cobra automáticamente en pesos argentinos, pesos mexicanos, pesos colombianos, soles peruanos, pesos chilenos, euros, quetzales, bolívares, colones, lempiras, balboas o córdobas.', 'O en tu moneda local de cualquier país!']
}, {
  question: '¿Funciona si tengo sensibilidad extrema a ciertos alimentos?',
  answer: ['Sí, porque es personalizable. El protocolo de 15 días es una estructura BASE y dentro de esa estructura VOS adaptás según tus disparadores personales.', 'El Mapa de Disparadores (Bono 4) te enseña exactamente a identificar y evitar TUS alimentos problemáticos específicos.']
}, {
  question: '¿Qué diferencia tiene el MegaPack con otros materiales que encontré?',
  answer: ['Otros materiales son reglas genéricas que no funcionan para todos. El MegaPack Salud Plena es un protocolo progresivo + herramientas para personalizar + 15 días de estructura + 6 bonos tácticos.', 'Acá no buscás información suelta en internet: tenés un sistema completo, ordenado y listo para implementar desde hoy.']
}];